import gql from 'graphql-tag';

export const leadSourcePartnersQuery = gql`
  query LeadSourcePartners($partnerType: String, $search: String, $limit: Int) {
    leadSourcePartnersQuery(partnerType: $partnerType, search: $search, limit: $limit) {
      _id
      displayName
      firstName
      lastName
      username
      email
      login
      phone
      partnerType
      platforms
      platformNicknames {
        platform
        nickname
      }
      products {
        productId
        productTitle
        productType

        priceOptionId
        priceTitle
        price
        discountPercent
        discountedPrice
        currency

        bonusValue
        bonusPaymentType
        rewardValue
        paymentType

        referralCode
        referralLink
        isActive
      }
      referralCode
    }
  }
`;
